export function updateSizeButtons(selectedSize) {
  const container = getContainer()
  if (!container) return
  
  const sizeButtons = getSizeButtons(container)
  sizeButtons.forEach(element => {
    updateButton(element, selectedSize)
  })
}

function getContainer() {
  return document.getElementById('size-holder')
}

function getSizeButtons(container) {
  return container.querySelectorAll('[data-controller~="size-picker"]')
}

function updateButton(element, selectedSize) {
  const controller = window.Stimulus?.getControllerForElementAndIdentifier(element, 'size-picker')
  controller?.updateSelection(selectedSize)
}
